import { apiPost } from '../support/helpers/ApiConnection.Helper';

export default function retryOneVendorDocumentDownload(
    referralId: number,
    documentId: number,
    abortSignal: AbortSignal,
): Promise<void> {
    return apiPost<void>('/referral-documents/' + referralId + '/vendor-document/' + documentId + '/retry-download', null, abortSignal);
}